import Vue from 'vue';
import Vuex from 'vuex';
import general from './modules/general';
import session from './modules/session';
import chat from './modules/chat';
import profile from './modules/profile';
import slack from './modules/slack';

Vue.use(Vuex);
const store = new Vuex.Store({
  modules: {
    general,
    session,
    chat,
    profile,
    slack
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js